import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import React from "react";
import { UseAppDispatch } from "redux/store";
import { useSelector } from "react-redux";

import { changeStops, filterSelector, IStops } from "redux/filters";
import { useTranslations } from "hooks/useTranslations";

import { IStopsFilter } from "hooks/translations.interfaces";
import { deepCloneObject, pushToDataLayer } from "@thekilroygroup/shared-ui";
import { Box, SxProps } from "@mui/material";

export default function Stops() {
  const dispatch = UseAppDispatch();
  const { stops } = useSelector(filterSelector);

  const { translations } = useTranslations();
  const translationsStopsFilter: IStopsFilter = deepCloneObject(
    translations.filters.filterTypes.filter((obj) => {
      return obj.filter === "stops";
    })[0],
  );

  const checkForTouched = (nextStops: IStops) => {
    if (
      nextStops.direct === true &&
      nextStops.oneStop === true &&
      nextStops.twoPlusStops === true
    ) {
      return false;
    }
    return true;
  };

  const handleChangeDirect = (
    element: React.ChangeEvent<HTMLInputElement>,
    value: boolean,
  ) => {
    const nextStops: IStops = deepCloneObject(stops);
    nextStops.direct = value;
    nextStops.touched = checkForTouched(nextStops);
    trackEvent(`Direct - Checked: ${value}`);
    dispatch(changeStops(nextStops));
  };

  const handleChangeOneStop = (
    element: React.ChangeEvent<HTMLInputElement>,
    value: boolean,
  ) => {
    const nextStops: IStops = deepCloneObject(stops);
    nextStops.oneStop = value;
    nextStops.touched = checkForTouched(nextStops);
    trackEvent(`1 stop - Checked: ${value}`);
    dispatch(changeStops(nextStops));
  };

  const handleChangeTwoPlusStops = (
    element: React.ChangeEvent<HTMLInputElement>,
    value: boolean,
  ) => {
    const nextStops: IStops = deepCloneObject(stops);
    nextStops.twoPlusStops = value;
    nextStops.touched = checkForTouched(nextStops);
    trackEvent(`2+ stops - Checked: ${value}`);
    dispatch(changeStops(nextStops));
  };

  const trackEvent = (included: string) => {
    pushToDataLayer(`${included}`, "Filter - Stops");
  };

  return (
    <>
      <Box sx={sxStyles.checkbox}>
        <FormControlLabel
          control={
            <Checkbox onChange={handleChangeDirect} checked={stops.direct} />
          }
          label={
            <>
              <Box sx={sxStyles.labelText}>
                <Typography variant="titleMedium" weight="bold">
                  {translationsStopsFilter.direct?.label}
                </Typography>
              </Box>
            </>
          }
          sx={sxStyles.label}
        />
      </Box>

      <Box sx={sxStyles.checkbox}>
        <FormControlLabel
          control={
            <Checkbox onChange={handleChangeOneStop} checked={stops.oneStop} />
          }
          label={
            <>
              <Box sx={sxStyles.labelText}>
                <Typography variant="titleMedium" weight="bold">
                  {translationsStopsFilter.oneStop?.label}
                </Typography>
              </Box>
            </>
          }
          sx={sxStyles.label}
        />
      </Box>

      <Box sx={sxStyles.checkbox}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleChangeTwoPlusStops}
              checked={stops.twoPlusStops}
            />
          }
          label={
            <>
              <Box sx={sxStyles.labelText}>
                <Typography variant="titleMedium" weight="bold">
                  {translationsStopsFilter.twoPlusStops?.label}
                </Typography>
              </Box>
            </>
          }
          sx={sxStyles.label}
        />
      </Box>
    </>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  links: {
    display: "grid",
    columnCount: 2,
    gridTemplateColumns: "1fr 1fr",
    columnGap: 2,
    mt: 6,
    mb: 9,
  },
  listTitle: {
    color: "primary.main",
    mt: 3,
    mb: 2,
  },
  accordion: {
    boxShadow: "none",
    borderTop: `1px solid`,
    borderTopColor: "grey.400",
    "&.Mui-expanded": {
      marginTop: 0,
    },
  },
  checkbox: {
    borderBottom: "1px solid",
    borderBottomColor: "grey.200",
    "&:last-of-type": {
      borderBottom: "0px solid",
    },
  },
  label: {
    my: 1,
  },
  labelText: {
    "& p": {
      fontWeight: "700",
    },
  },
};
